function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".error-modal_size", shadowSelector, " {height: 300px;}.error-modal-footer_alignment", shadowSelector, " {height: 75px;}.error-modal-data-table_style", shadowSelector, " {padding-top: 10px;width: 200px;padding-left: 15px;}.error-modal-button_pos", shadowSelector, " {right: 750px;}"].join('');
}
export default [stylesheet];